// extracted by mini-css-extract-plugin
export default {"wrapper":"WaterModal_wrapper__+R9-0","title":"WaterModal_title__OW0hl","subtitle":"WaterModal_subtitle__PGJW3"};